module.exports = __webpack_public_path__ + "img/goods16-2.d2cc0620.jpg";